import { combineReducers } from 'redux';

import applicationReducer from './application/application.reducer';
import moduleReducer from './module/module.reducer';
import userReducer from './user/user.reducer';

export default combineReducers({
    application: applicationReducer,
    module: moduleReducer,
    user: userReducer
});